import useSWR from "swr";
import { fetcher } from "lib/actions/fetcher";
import { endpointsAutodesk } from "lib/actions/endpoints/endpointsAutodesk";
import { AutodeskAccountModel } from "lib/types/autodesk/AutodeskAccountModel";

/**
 * The caller's own connected accounts in one workspace.
 *
 * The route is deliberately not workspace-scoped (it answers "what have I
 * connected", which spans every workspace), so the workspace filter happens
 * here. That keeps it usable by a member, who cannot read the workspace-wide
 * listing: that one is behind ManageWorkspace.
 */
export function useAutodeskUserAccounts(workspaceId: number) {
  const {
    data: accounts,
    error,
    isLoading,
    mutate,
  } = useSWR<AutodeskAccountModel[]>(endpointsAutodesk.userAccounts, fetcher);

  return {
    accounts: (accounts ?? []).filter((a) => a.workspaceId === workspaceId),
    isLoading,
    hasError: !!error,
    mutate,
  };
}
